<flo-simple-header [siteId]="siteId$ | async"></flo-simple-header>

<div class="promo-gift-container d-none d-md-block" *ngIf="shouldShowWrestlingGiftPromo$ | async as shouldShowWrestlingGiftPromo">
  <img class="promo-gift-banner-image no-skeleton" src="https://d6fm3yzmawlcs.cloudfront.net/funnelAssets/dark-theme/flowrestling-shirt-promo-banner-2.png" alt="Promo Gift Banner">
  <div class="promo-gift-banner">Get a FREE T-shirt and 12 Months for the Price of 5 with an Annual plan.</div>
</div>

<div class="container">
  <flo-stepper-wrapper *ngIf="!(isEmbeddedPurchase$ | async)" data-test="stepper" ></flo-stepper-wrapper>
  <h1 *ngIf="!(isIn2025PlansPageVariation$ | async) " data-test="funnel-title" class="funnel-title mt-25">Choose Your Plan</h1>
  <h1 *ngIf="(isIn2025PlansPageVariation$ | async) " data-test="funnel-title" class="funnel-title mt-25">Pick a Plan</h1>

   <!-- LEGACY PLANS DT / MOBILE -->
  <ng-container *ngIf="!(isInSingleClickDesktopPlansVariation$ | async) && !(isInSingleClickMobilePlansVariation$ | async)">
    <div class="funnel-button-wrapper">
      <button
        data-id="pay-button"
        floAnalytics
        name="Go To Pay"
        class="btn btn-primary selection-btn btn-lg w-100 lg-font-btn"
        (click)="goToNextPage()"
        data-test="go-to-pay-button"
        >Next
      </button>
    </div>

    <div class="main-content" data-test="legacy-content-section">
      <ng-container *ngIf="!(isWrestling$ | async); else displayOldPlans">
        <flo-offers
          data-test="offers"
          [selectedOffer]="selectedOffer$ | async"
          [offers]="offers$ | async"
        ></flo-offers>
      </ng-container>
      <ng-template #displayOldPlans>
        <flo-offers
          *ngIf="legacyPlansConfig$ | async as legacyPlansConfig"
          data-test="legacy-plans"
          [legacyPlans]="legacyPlans"
          [offers]="legacyPlansConfig.offers"
          [selectedOffer]="legacyPlansConfig.selectedOffer"
        ></flo-offers>
      </ng-template>
      <!-- only displayed on mobile view -->
      <div
        *ngIf="valueProps$ | async as valueProps"
        class="mobile-value-props d-block d-md-none"
        data-test="mobile-value-props"
      >
        <div class="plan-props-header"><h4>Included with the Selected Plan</h4></div>
        <flo-value-prop
          *ngFor="let valueProp of valueProps; trackBy: trackById"
          [label]="valueProp.style"
          [proposition]="valueProp.text"
          svgWidth="18">
        </flo-value-prop>
      </div>
    </div>
  </ng-container>

  <!-- END LEGACY PLANS DT / MOBILE -->

  <!-- CXP-8819: Single-Click Desktop Plans -->
  <div class="main-content gap-0" *ngIf="isInSingleClickDesktopPlansVariation$ | async as isSingleClickDT" data-test="single-click-dt-plans-section">
    <!-- Offer Cards -->
    <div class="offers-wrapper gap-4 d-flex justify-content-center" *ngIf="offers$ | async as offers">
      <div class="offer-container" *ngFor="let offer of offers; trackBy: trackById;">
        <flo-offer-button-card
          [offer]="offer"
          [isMonthly]="offer.offerMetadata.period !== 'year'"
          [buttonText]="'Select'"
          [pricePeriod]="'/month'"
          [showValueProps]="true"
          [showSavings]="true"
          [showSavingsValueProp]="!isSingleClickDT"
          (offerSelected)="onOfferSelected($event)"
          ></flo-offer-button-card>
      </div>
    </div>
  </div>


  <!-- CXP-7255: Single-Click Mobile Plans -->
   <div class="main-content gap-0" *ngIf="isInSingleClickMobilePlansVariation$ | async" data-test="single-click-mobile-plans-section">
      <!-- Offer Cards -->
      <div class="offers-wrapper gap-4 d-flex flex-column" *ngIf="offers$ | async as offers">
        <div *ngFor="let offer of offers; trackBy: trackById;">
          <flo-offer-button-card
            [offer]="offer"
            [isMonthly]="offer.offerMetadata.period !== 'year'"
            [buttonText]="'Select'"
            [pricePeriod]="'/month'"
            [showSavings]="true"
            [showMoreBillingInfo]="true"
            (offerSelected)="onOfferSelected($event)"
            ></flo-offer-button-card>
        </div>
      </div>

      <!-- Value Props -->
       <div class="value-props-wrapper d-flex flex-column" *ngIf="valueProps$ | async as valueProps">
          <h2 class="value-props-title">Included in all plans</h2>
          <div>
              <flo-value-prop
                  *ngFor="let valueProp of valueProps; trackBy: trackById"
                  [proposition]="valueProp"
                  label="single-click-plans"
                  svgWidth="18"
              ></flo-value-prop>
          </div>
       </div>
   </div>

</div>
